/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */

import { Window_FillRateFallback } from './Window_FillRateFallback';
import { Window } from '../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import { LevelType } from '../GameState/Managers/GameEnums';

/**
 * Level failed window
 */
class Window_LevelFailed extends Window {
  /**
   * constructor
   * @param {Object} parent
   * @param {Object} msg_payload
   */
  constructor(parent) {
    super(parent);

    G.sb('onLevelFailed').dispatch();
    if (G.MYSTERYGIFT) G.saveState.mysteryGift_finishStreak(G.lvlNr === G.saveState.getLastPassedLevelNr());
    if (this.state.mode === LevelType.CHALLENGE) G.sb('onDailyChallengeFinished').dispatch();

    // Schedule a bot message to remind player when they get full lives if they don't have
    // unlimited lives or full lives
    if (G.saveState.getUnlimitedLivesSec() <= 0 && G.saveState.data.lives < G.json.settings.livesMax) {
      // Calculate time to 5 lives in seconds
      const timeToFullLives = G.saveState.getSecUntilFullLives();

      OMT.notifications.scheduleGameTriggeredMessage(OMT.envData.settings.user.userId, 'FullLives', timeToFullLives, null, false);
    }

    // console.log('Lvl finished', G.lvl.lvlIndex + 1, G.lvl.points);
    // sdkHandler.trigger('levelFinish', {
    //   level: G.lvl.lvlIndex + 1,
    //   score: G.lvl.points,
    //   state: 'lose',
    // }, this);

    this._initLayout();
    this._initButtons();
  }

  /**
   * init window layout
   */
  _initLayout() {
    // background
    this.addBackground('popup_background_2');

    // banner
    if (G.OMTsettings.global.jungleMatch) {
      this._blue_banner = G.makeImage(0, -295, 'purple_banner', 0.5, this);
      this.addChild(this._blue_banner);
    }

    const yOffset = G.OMTsettings.global.jungleMatch ? -297 : -272;

    // level title text
    this.levelTxt = new G.Text(0, yOffset,
      this.state.mode === LevelType.NORMAL ? (`${OMT.language.getText('Level')} ${G.lvl.lvlIndex + 1}`) : OMT.language.getText('Daily Challenge'),
      G.OMTsettings.global.window.mediumTitle.textStyle, 0.5, 380);
    this.add(this.levelTxt);

    // failed graphic
    if (G.LIVES && this.state.mode === LevelType.NORMAL && this.state._removedLifeAtStart) {
      this.diamond = G.makeImage(0, -75, 'sad_gingy_heart_small', 0.5, this);
    } else {
      this.diamond = G.makeImage(0, -75, 'failed_dimond', 0.5, this);
    }

    // level goal
    if (G.lvl.goalMgr.isPointBased()) {
      this.add(new G.Text(0, 100, `${OMT.language.getText('points').toUpperCase()}:\n${G.lvl.points}/${G.lvl.goalMgr.getPointTarget()}`, {
        style: 'font-purple',
        fontSize: '50px',
      }, 0.5, 380));
    } else {
      this._makeLevelFailedTaskCollectPanels(95);
    }
  }

  /**
   * init window buttons
   */
  _initButtons() {
    // close button
    this.closeButton = new G.Button(230, -255, 'btn_x', function () {
      sdkHandler.trigger('playButtonPressed', {
        callback: () => {
          G.sb('onStateChange').dispatch('World', undefined, () => {
            if (G.saveState.getLives() === 0 && G.saveState.getUnlimitedLivesSec() === 0) {
              G.sb('pushWindow').dispatch(['notEnoughLives'], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
            }
          });
        }
      }, this);
      this.closeButton.scale.x = this.closeButton.scale.y = 0.9;
      // this.state.endPointCheckForAds(() => {
      //   G.sb('onStateChange').dispatch('World', undefined, () => {
      //     if (G.saveState.getLives() === 0 && G.saveState.getUnlimitedLivesSec() === 0) {
      //       G.sb('pushWindow').dispatch(['notEnoughLives'], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
      //     }
      //   });
      // });
    }, this);
    this.registerButtons(this.closeButton);
    this.closeButton.visible = false;
    sdkHandler.trigger('beforePlayButtonDisplay', {
      callback: () => {
        this.closeButton.visible = true;
      }
    }, this);

    // retry buttons
    if (this.state.mode === LevelType.NORMAL) {
      const onClick = () => {
        G.winsInRow = 0;
        G.saveState.resetCWinCount();

        if (G.saveState.getLives() > 0 || G.saveState.getUnlimitedLivesSec() > 0) {
          this.closeWindow();
          sdkHandler.trigger('playButtonPressed', {
            callback: () => {
              G.sb('pushWindow').dispatch(['level', G.lvl.lvlIndex, { showPointer: Math.random() < 0.5 }], false, 'retryLevel');
            }
          }, this);
          // this.state.endPointCheckForAds(() => {
          //   G.sb('pushWindow').dispatch(['level', G.lvl.lvlIndex, { showPointer: Math.random() < 0.5 }], false, 'retryLevel');
          // });
        } else {
          this.closeWindow();
          sdkHandler.trigger('playButtonPressed', {
            callback: () => {
              G.sb('pushWindow').dispatch(['notEnoughLives', {
                openLevelPopUp: true,
                lvlIndex: G.lvl.lvlIndex,
                levelPopUpLayerName: game.state.current === 'Game' ? 'retryLevel' : G.WindowMgr.LayerNames.Base,
              }]);
            }
          }, this);
          // this.state.endPointCheckForAds(() => {
          //   G.sb('pushWindow').dispatch(['notEnoughLives', {
          //     openLevelPopUp: true,
          //     lvlIndex: G.lvl.lvlIndex,
          //     levelPopUpLayerName: game.state.current === 'Game' ? 'retryLevel' : G.WindowMgr.LayerNames.Base,
          //   }]);
          // });
        }
      };
      this.retryBtn = new OMT_UI_SquareButton(5, 240, {
        button: {
          tint: BUTTONCOLOURS.orange,
          dimensions: {
            width: 196,
            height: 100,
          },
          extraDetail: false,
        },
        text: {
          string: OMT.language.getText('Retry'),
          textStyle: {
            style: 'font-white',
            fontSize: 50,
          },
          dimensionMods: {
            height: 0.9,
            width: 0.9,
          },
        },
        options: {
          clickFunction: {
            onClick: onClick.bind(this),
          },
        },
      });
      this.registerButtons(this.retryBtn);
      this.retryBtn.visible = false;
      sdkHandler.trigger('beforePlayButtonDisplay', {
        callback: () => {
          this.retryBtn.visible = true;
        }
      }, this);

    } else {
      const continueClick = () => {
        sdkHandler.trigger('playButtonPressed', {
          callback: () => {
            G.sb('onStateChange').dispatch('World');
          }
        }, this);
        // this.state.endPointCheckForAds(() => {
        //   G.sb('onStateChange').dispatch('World');
        // });
      };
      this.continueBtn = new OMT_UI_SquareButton(0, 230, {
        button: {
          tint: BUTTONCOLOURS.green,
          dimensions: {
            width: 196,
            height: 100,
          },
        },
        text: {
          string: OMT.language.getText('Continue'),
          textStyle: {
            style: 'font-white',
            fontSize: 70,
          },
        },
        options: {
          clickFunction: {
            onClick: continueClick.bind(this),
          },
        },
      });
      this.registerButtons(this.continueBtn);
      this.continueBtn.visible = false;
      sdkHandler.trigger('beforePlayButtonDisplay', {
        callback: () => {
          this.continueBtn.visible = true;
        }
      }, this);

      if (game.incentivised()) {
        this.retryBtn = this._initRetryAdButton(120, 230);
        // this.continueBtn.x = this.retryBtn.x - (this.continueBtn.width) + (this.continueBtn.width / 8) - (this.retryBtn.width / 2);
        this.continueBtn.x = -this.retryBtn.x;
      }
    }
  }

  /**
   * make level task panels
   * @param {number} y
   */
  _makeLevelFailedTaskCollectPanels(y) {
    const posX = [
      [0],
      [-85, 85],
      [-170, 0, 170],
      [-205, -65, 65, 205],
    ];
    this.taskBg = G.makeImage(0, y, 'popup_bigtext_backgr', 0.5, this);
    this.taskBg.scale.set(1, 1.2);
    this.panels = [];
    const goals = G.lvl.goal[1];
    const len = goals.length;
    for (let i = 0; i < len; i++) {
      if (this.state.topBar.goalPanel.panels[i].amount > 0) {
        const gfxName = G.json['configs/gameplayGoals'][goals[i][0]].sprite;
        const panel = G.makeImage(0, y,
          gfxName,
          0.5, this);
        panel.scale.set(0.8);
        G.makeImage(70, 0, 'task_fail', 0.5, panel);
        this.panels.push(panel);
      }
    }
    const nrOfPanels = this.panels.length;
    this.panels.forEach((panel, index) => {
      panel.x = G.l(posX[nrOfPanels - 1][index] - 25);
    });
  }

  /**
   * on retry ad shown
   */
  _retryAdSuccess() {
    if (this.state.mode === LevelType.CHALLENGE) {
      G.saveState.enableRewardedChallenge();
    }
    G.sb('pushWindow').dispatch(['dailyChallenge', G.saveState.getDailyChallengeLevel(), { showPointer: Math.random() < 0.5 }], false, 'retryLevel');
    this.closeWindow();
  }

  /**
   * init the retry ad button
   * @param {number} x
   * @param {number} y
   */
  _initRetryAdButton(x, y) {
    const onClick = () => {
      sdkHandler.trigger('rewardedAd', {
        callback: (success) => {
          if (success) { this._retryAdSuccess(); }
          else {/* 'no more videos screen */
            new Window_FillRateFallback(undefined, {
              placement: G.BuildEnvironment.adPlacements.retryChallenge,
              callback: this._retryAdSuccess.bind(this),
              context: this,
            });
          }
        }
      }, this);
      // OMT.ads.showAd(
      //   G.BuildEnvironment.adPlacements.retryChallenge,
      //   this._retryAdSuccess.bind(this),
      //   () => {
      //     if (!G.IAP) { // no IAPS dont use ad fallbacks
      //       // eslint-disable-next-line no-new
      //       new Window_FillRateFallback(undefined, {
      //         placement: G.BuildEnvironment.adPlacements.retryChallenge,
      //         callback: this._retryAdSuccess.bind(this),
      //         context: this,
      //       });
      //     } else { // open ad fallback
      //       OMT.ads.showAdFallback(this._retryAdSuccess.bind(this));
      //     }
      //   },
      // );
    };
    const group = this.add(game.make.group());
    group.position.setTo(x, y);
    const adImg = G.makeImage(0, 0, 'btn-movie-icon', 0.5, null);
    group.btn = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.purple,
        dimensions: {
          width: 230,
          height: 100,
        },
        extraDetail: false,
      },
      text: {
        string: OMT.language.getText('Retry'),
        textStyle: {
          style: 'font-white',
          fontSize: 50,
        },
        icon: {
          image: adImg,
          offset: {
            x: adImg.width / 3,
          },
          align: 'left',
        },
        offset: {
          x: adImg.width / 4,
        },
        dimensionMods: {
          height: 0.9,
          width: 0.55,
        },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });
    group.add(group.btn);
    // group.icon = G.makeImage(0, 0, 'btn-movie-icon', 0.5, this);
    // group.add(group.icon);
    // group.text = new G.Text(0, 0, OMT.language.getText('Retry'), 'window-white', 0.5, 150);
    // group.text.setShadow(2, 3, 'rgba(0,0,0,0.5)', 0);
    // group.add(group.text);
    // G.centerElements2([group.icon, group.text], 5, 0);
    // group.btn.width = group.icon.width + group.text.width + 5 + 40;
    // group.btn.scale.x = Math.max(1, group.btn.scale.x);
    return group;
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.levelFailed = Window_LevelFailed;
